import React, { useCallback, useEffect, useMemo, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import InfiniteScrollComponent from "../../../../../components/Common/InfiniteScroll/InfiniteScrollComponent";
import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
import classes from "./SeriesContent.module.scss";
import Tooltip from "../../../../../components/Common/ToolTip/Tooltip";
import InfoIcon from "../../../../../components/Common/SvgIcons/SocialIcons/InfoIcon";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import Input from "../../../../../components/Common/Input/Input";
import { useDispatch } from "react-redux";
import {
  setOrganizeContentDataAction,
  setSeriesShotclassDataAction,
} from "../../../../../store/actions/actionCreators/organizeActionCreator";
import NextIcon from "../../../../../components/Common/SvgIcons/CommonIcons/NextIcon";
import CrossIcon from "../../../../../components/Common/SvgIcons/SocialIcons/CrossIcon";
import { addNewTopic } from "../../../../../utils/mainTabs/organize/addNewTopic";
import Button from "../../../../../components/Common/Button/Button";
import { useSelector } from "react-redux";
import { seriesManagement } from "../../../../../utils/mainTabs/organize/seriesManagement";
import { addSeriesMgmt } from "../../../../../utils/mainTabs/organize/addSeriesMgmt";
import {
  getRecentlyAddNewSeriesActionHandler,
  postEditSeriesCertificateActionHandler,
  postSeriesProgramActionHandler,
  searchProgramActionHandler,
  updateProgramActionHandler,
} from "../../../../../store/actions/actionHandlers/organizeActionHandler";
import { setErrorHandler } from "../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../utils/errorTypes";
import useHashArray from "../../../../../hooks/useHashArray";
import { IoMdMove } from "react-icons/io";
import Loader from "../../../../../components/Common/Loader/Loader";
import moment from "moment";
import { postCertificateActionHandler } from "../../../../../store/actions/actionHandlers/distributeActionHandler";
import { FormattedMessage } from "react-intl";

const SeriesContent = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const routerParam = useParams();
  const pageSize = 8;
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;
  const [selectedTopicData, setSelectedTopicData] = useState([]);
  const [selectedTopicIds, setSelectedTopicIds] = useState([]);
  const [imageUrl, setImageUrl] = useState("");

  const [selectedShotClassIds, setSelectedShotClassIds] = useState([]);
  const [selectedProgramIds, setSelectedProgramIds] = useState([]);

  const [selectedTrainingIds, setselectedTrainingIds] = useState([]);
  const [movedTopicData, setMovedTopicData] = useState([]);
  const [movedTopicDataByCross, setmovedTopicDataByCross] = useState([]);
  const contentData = useSelector((state) => state.organizeReducer);
  const { organizeContentData } = contentData;
  const [selectedTpc, setSelectedTpc] = useState(organizeContentData);
  const [pageNum, setPageNum] = useState(1);
  const [hasMoreData, setHasMoreData] = useState(true);

  // const [classTypeData, setClassTypeData] = useState([]);

  const [alreadyPresentTopic, setAlreadyPresentTopic] = useState([]);
  const [activeData, setActiveData] = useState(false);
  const [checkBoxCheckedClass, setcheckBoxCheckedClass] = useState(true);
  const [checkBoxCheckedProgram, setcheckBoxCheckedProgram] = useState(false);

  const [topicCourseAssociations, setTopicCourseAssociations] = useState([]);
  const [hidePopUp, setHidePopUp] = useState(false);
  const [topicCourseHeading, setTopicCourseHeading] = useState();
  const [activeLoader, setActiveLoader] = useState(false);
  const [seriesLoader, setSeriesLoader] = useState(false);
  const [seriesPublishLoader, setSeriesPublishLoader] = useState(false);
  const [isClassSelected, setIsClassSelected] = useState(false);
  // const organizeState = useSelector((state) => state.organizeReducer);
  // const { seriesShotclassData } = organizeState;
  const {
    formData,
    setFormData,
    shotClassCount,
    setShotClassCount,
    classTypeData,
    pathType,
    dataForUpdateProgramByID,
    tenantName,
    callDefaultApi,
    setCallDefaultApi,
  } = useOutletContext();
  const methods = useForm({
    mode: "onChange",
    // resolver: yupResolver(topicContentSchema),
    defaultValues: useMemo(() => {
      return {
        ...formData.details,
        ...formData.topicContent,
      };
    }, [formData.details, formData.topicContent]),
  });
  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    reset,
    setValue,
  } = methods;
  // useEffect(() => {
  //   dispatch(
  //     getRecentlyAddNewSeriesActionHandler(
  //       "WithoutVTLT",
  //       "Published",
  //       "ShotClass",
  //       "none",
  //       "none",
  //       1,
  //       pageSize
  //     )
  //   );
  // }, [dispatch]);
  // useEffect(() => {
  //   setClassTypeData(seriesShotclassData);
  //   // dispatch(setOrganizeContentDataAction(selectedTpc));
  //   // setSelectedTpc(organizeContentData);
  // }, [
  //   seriesShotclassData,
  //   setClassTypeData,
  //   classTypeData,
  //   // setSelectedTpc,
  //   // organizeContentData,
  //   // alreadyPresentTopic,
  // ]);
  const [checkSearchTxt, setCheckSearchTxt] = useState(true);

  useEffect(() => {
    setCallDefaultApi(false);
    if (pageNum > 1) {
      dispatch(
        getRecentlyAddNewSeriesActionHandler(
          "WithoutVTLT",
          "Published",
          "ShotClass",
          "none",
          "none",
          pageNum,
          pageSize,
          callDefaultApi
        )
      );
    }
    // }
  }, [pageNum]);
  const fetchMoreData = () => {
    if (classTypeData?.length >= shotClassCount) {
      setHasMoreData(false);
      return;
    }
    setCallDefaultApi(true);
    setCheckSearchTxt(true);
    if (checkSearchTxt) {
      setPageNum((prevState) => prevState + 1);
    }
  };
  const handleTopics = (e, data, index) => {
    if (e.target.checked === true) {
      //selectedTopicData.push(data);
      if (!selectedTopicData.find((item) => item.ID === data.ID)) {
        selectedTopicData.push(data);
      }
      selectedTopicIds.push(data.ID);
      selectedShotClassIds.push(data?.ID);
      const updatedData = classTypeData?.map((item) => {
        if (item?.ShotClass?.ID === data?.ID) {
          return { ...item, isChecked: true, disabled: false };
        } else return item;
      });
      dispatch(setSeriesShotclassDataAction(updatedData));
    } else {
      const updatedArr = selectedTopicData.filter(
        (dataVal) => dataVal.ID !== data.ID
      );
      setSelectedTopicData(updatedArr);
      const updateSelectedTopicIDs = selectedTopicIds.filter(
        (dataValID) => dataValID !== data.ID
      );
      setSelectedTopicIds(updateSelectedTopicIDs);
      const updatedData = classTypeData?.map((item) => {
        if (item?.ShotClass?.ID === data?.ID) {
          return { ...item, isChecked: false, disabled: false };
        } else return item;
      });
      dispatch(setSeriesShotclassDataAction(updatedData));
    }
  };
  const handleNextBtn = () => {
    const updatedData = classTypeData?.map((item) => {
      if (item?.isChecked) {
        return { ...item, disabled: true };
      } else return item;
    });
    dispatch(setSeriesShotclassDataAction(updatedData));

    setSelectedTpc((prev) => [...prev, ...selectedTopicData]);

    setSelectedTopicData([]);
  };

  const handleTrainingContent = (e, data) => {
    if (e.target.checked === true) {
      movedTopicData.push(data?.ID);
      setIsClassSelected(true);
    } else {
      const updatedArr = movedTopicData.filter(
        (dataVal) => dataVal !== data.ID
      );
      setMovedTopicData(updatedArr);
      setIsClassSelected(updatedArr.length > 0);
    }
  };
  const handlePrevBtn = (e) => {
    const updatedArr = classTypeData.map((data) => {
      if (movedTopicData.includes(data?.ShotClass?.ID)) {
        return { ...data, isChecked: false, disabled: false };
      } else return data;
    });
    dispatch(setSeriesShotclassDataAction(updatedArr));
    const updateRightData = selectedTpc.filter(
      (dataVal) => !movedTopicData.includes(dataVal?.ID)
    );
    setSelectedTpc(updateRightData);
    setMovedTopicData([]);
    setIsClassSelected(false);
  };
  const handleCrossIcon = (data) => {
    movedTopicDataByCross.push(data?.ID);
    const updatedArr = classTypeData.map((data) => {
      if (movedTopicDataByCross.includes(data?.ShotClass?.ID)) {
        return { ...data, isChecked: false, disabled: false };
      } else return data;
    });
    dispatch(setSeriesShotclassDataAction(updatedArr));
    const updatedTopics = selectedTpc.filter(
      (dataVal) => dataVal?.ID !== data?.ID
    );
    setSelectedTpc(updatedTopics);
  };
  const onSubmit = (data) => {
    let tagsName = formData.details.TagsList.map((item) => {
      return item?.TagName.toString();
    });
    var listofClasses = "";
    var order = 1;
    elementsSelectedTopic.forEach((element) => {
      listofClasses =
        listofClasses + "0," + element.ID.toString() + "," + order + ";";
      order = order + 1;
    });
    if (pathType === "edit") {
      setSeriesPublishLoader(true);
      let dueDateInFormat = new Date(formData?.details?.DueDate);
      let day = dueDateInFormat.getDate();
      let week = dueDateInFormat.getDay();
      let month = dueDateInFormat.getMonth();
      let year = dueDateInFormat.getFullYear().toString().slice(-2);
      // console.log(week + "/" + month + "/" + day + "/" + year);
      let daysInChar = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      let monthInChar = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let weekDay;
      daysInChar.forEach((day, index) => {
        // Check if the index of day value is equal to the returned value of getDay()
        if (index == week) {
          weekDay = day;
        }
      });
      let monthChar;
      monthInChar.forEach((day, index) => {
        // Check if the index of day value is equal to the returned value of getFullYear()
        if (index == month) {
          monthChar = day;
        }
      });
      let fullDateFormat = weekDay + ", " + day + " " + monthChar + " " + year;
      let updatedPostData = {
        CanDisplayClassPostDuedate: false,
        Count: 20,
        Description: formData?.details?.description,
        DueDate: fullDateFormat.toString(),
        ID: dataForUpdateProgramByID?.[0]?.Programs?.ID,
        ImageUrl: formData?.details?.ThumbnailImage?.ThumbnailUri
          ? formData?.details?.ThumbnailImage?.ThumbnailUri
          : dataForUpdateProgramByID?.[0]?.Programs?.ImageUrl,
        IsPremium: dataForUpdateProgramByID?.[0]?.Programs?.IsPremium,
        IsPublished: dataForUpdateProgramByID?.[0]?.Programs?.IsPublished
          ? "false"
          : "true",
        IsSelfPacedProgram: formData?.details?.IsSelfPacedProgram,
        IsSpreadProgram: formData?.details?.IsSpreadProgram,
        LearningCredits:
          dataForUpdateProgramByID?.[0]?.Programs?.LearningCredits,
        ListOfClasses: listofClasses,
        Name: formData?.details?.name,
        NoDaysToNotifyBeforeDueDate:
          formData?.details?.NoDaysToNotifyBeforeDueDate,
        Order: dataForUpdateProgramByID?.[0]?.Programs?.Order,
        PageNum: 1,
        Status: "Saved",
        Tags: tagsName.toString(),
        Type: "Program",
      };
      dispatch(
        updateProgramActionHandler(updatedPostData, navigate, tenantName)
      ).then((response) => {
        if (response) {
          if (formData?.details?.Certificate && formData?.details?.Title) {
            const certificatePayload = {
              CertificateID: parseInt(formData?.details?.Certificate),
              ProgramID: dataForUpdateProgramByID?.[0]?.Programs?.ID,
              ProgramName: formData.details.name,
              Title: formData?.details?.Title,
              Type: true,
            };
            dispatch(
              postEditSeriesCertificateActionHandler(certificatePayload)
            );
          }
          setSeriesPublishLoader(false);
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `Program Updated and ${
                dataForUpdateProgramByID?.[0]?.Programs?.IsPublished
                  ? "Unpublished"
                  : "Published"
              } Successfully`
            )
          );
          navigate(
            `${addSeriesMgmt.path(
              location,
              routerParam,
              tenantName
            )}/publishSeries`
          );
        }
      });
    } else {
      setSeriesPublishLoader(true);
      setFormData((formData) => {
        return {
          ...formData.details,
          topicContent: {
            ...formData.topicContent,
            TopicCourseAssociations: topicCourseAssociations,
          },
        };
      });
      let postData = {
        CanDisplayClassPostDuedate:
          formData?.details?.CanDisplayClassPostDuedate,
        Count: 20,
        Description: formData.details.description,
        DueDate: !formData?.details?.CanDisplayClassPostDuedate
          ? moment(formData?.details?.DueDate).format("ddd, DD MMM YYYY")
          : "",
        ImageUrl: formData.details.ThumbnailImage.ThumbnailUri
          ? formData.details.ThumbnailImage.ThumbnailUri
          : formData?.details?.ThumbnailImage,
        IsPublished: data.publishbtn ? true : false,
        IsSelfPacedProgram: formData?.details?.IsSelfPacedProgram,
        IsSpreadProgram: formData?.details?.IsSpreadProgram,
        LearningCredits: "",
        ListOfClasses: listofClasses,
        Name: formData.details.name,
        NoDaysToNotifyBeforeDueDate:
          formData?.details?.NoDaysToNotifyBeforeDueDate,
        Order: "0",
        PageNum: 1,
        Status: "Saved",
        Tags: tagsName?.toString(),
        Type: "Program",
      };
      dispatch(
        postSeriesProgramActionHandler(
          postData,
          dispatch,
          navigate,
          pathType,
          tenantName
        )
      ).then((response) => {
        if (response.status === 200) {
          if (formData?.details?.Certificate) {
            const certificateObj = {
              CertificateID: parseInt(formData?.details?.Certificate),
              ProgramName: formData.details.name,
              Title: formData?.details?.Title,
              Type: true,
            };
            dispatch(postCertificateActionHandler(certificateObj));
          }
          setSeriesPublishLoader(false);
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              "Program Published Successfully"
            )
          );
          navigate(
            `${addSeriesMgmt.path(
              location,
              routerParam,
              tenantName
            )}/publishSeries`
          );
          // dispatch(setSeriesShotclassDataAction([]));
        }
      });
    }
  };
  const saveSeries = () => {
    var listofClasses = "";
    var order = 0;
    elementsSelectedTopic.forEach((element, index) => {
      order = order + 1;
      listofClasses =
        listofClasses + "0," + element.ID.toString() + "," + order + ";";
    });
    let tagsName = formData.details.TagsList.map((item) => {
      return item?.TagName.toString();
    });
    if (pathType === "edit") {
      setSeriesLoader(true);
      let dueDateInFormat = new Date(formData?.details?.DueDate);
      let day = dueDateInFormat.getDate();
      let week = dueDateInFormat.getDay();
      let month = dueDateInFormat.getMonth();
      let year = dueDateInFormat.getFullYear().toString().slice(-2);
      // console.log(week + "/" + month + "/" + day + "/" + year);
      let daysInChar = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      let monthInChar = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      let weekDay;
      daysInChar.forEach((day, index) => {
        // Check if the index of day value is equal to the returned value of getDay()
        if (index == week) {
          weekDay = day;
        }
      });
      let monthChar;
      monthInChar.forEach((day, index) => {
        // Check if the index of day value is equal to the returned value of getFullYear()
        if (index == month) {
          monthChar = day;
        }
      });
      let fullDateFormat = weekDay + ", " + day + " " + monthChar + " " + year;
      let updatedPostData = {
        CanDisplayClassPostDuedate:
          !formData?.details?.CanDisplayClassPostDuedate,
        Count: 20,
        Description: formData?.details?.description,
        DueDate: fullDateFormat.toString(),
        ID: dataForUpdateProgramByID?.[0]?.Programs?.ID,
        ImageUrl: formData?.details?.ThumbnailImage?.ThumbnailUri
          ? formData?.details?.ThumbnailImage?.ThumbnailUri
          : dataForUpdateProgramByID?.[0]?.Programs?.ImageUrl,
        IsPremium: dataForUpdateProgramByID?.[0]?.Programs?.IsPremium,
        IsPublished: dataForUpdateProgramByID?.[0]?.Programs?.IsPublished,
        IsSelfPacedProgram: formData?.details?.IsSelfPacedProgram,
        IsSpreadProgram: formData?.details?.IsSpreadProgram,
        LearningCredits:
          dataForUpdateProgramByID?.[0]?.Programs?.LearningCredits,
        ListOfClasses: listofClasses,
        Name: formData?.details?.name,
        NoDaysToNotifyBeforeDueDate:
          formData?.details?.NoDaysToNotifyBeforeDueDate,
        Order: dataForUpdateProgramByID?.[0]?.Programs?.Order,
        PageNum: 1,
        Status: "Saved",
        Tags: tagsName.toString(),
        Type: "Program",
      };
      dispatch(
        updateProgramActionHandler(updatedPostData, navigate, tenantName)
      ).then((response) => {
        if (response) {
          if (formData?.details?.Certificate && formData?.details?.Title) {
            const certificatePayload = {
              CertificateID: parseInt(formData?.details?.Certificate),
              ProgramID: dataForUpdateProgramByID?.[0]?.Programs?.ID,
              ProgramName: formData.details.name,
              Title: formData?.details?.Title,
              Type: true,
            };
            dispatch(
              postEditSeriesCertificateActionHandler(certificatePayload)
            );
          }
          setSeriesLoader(false);
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Program Updated Successfully")
          );
          navigate(`${seriesManagement.path(tenantName)}`);
        }
      });
    } else {
      setSeriesLoader(true);
      setFormData((formData) => {
        return {
          ...formData.details,
          topicContent: {
            ...formData.topicContent,
            TopicCourseAssociations: topicCourseAssociations,
          },
        };
      });
      let postData = {
        CanDisplayClassPostDuedate:
          formData?.details?.CanDisplayClassPostDuedate,
        Count: 20,
        Description: formData?.details?.description,
        DueDate: !formData?.details?.CanDisplayClassPostDuedate
          ? moment(formData?.details?.DueDate).format("ddd, DD MMM YYYY")
          : moment(new Date()).add(3, "years").format("ddd, DD MMM YY"),
        ImageUrl: formData?.details?.ThumbnailImage?.ThumbnailUri
          ? formData?.details?.ThumbnailImage?.ThumbnailUri
          : formData?.details?.ThumbnailImage,
        IsSelfPacedProgram: formData?.details?.CanDisplayClassPostDuedate
          ? false
          : formData?.details?.IsSelfPacedProgram,
        IsSpreadProgram: formData?.details?.CanDisplayClassPostDuedate
          ? false
          : formData?.details?.IsSpreadProgram,
        LearningCredits: "",
        ListOfClasses: listofClasses,
        Name: formData?.details?.name,
        NoDaysToNotifyBeforeDueDate:
          formData?.details?.NoDaysToNotifyBeforeDueDate,
        Order: "0",
        PageNum: 1,
        Status: "Saved",
        Tags: tagsName?.toString(),
        Type: "Program",
      };
      // if (pathType === "copy")
      //   postData = {
      //     ...postData,
      //     ID: dataForUpdateProgramByID?.[0]?.Programs?.ID,
      //   };
      // debugger;
      dispatch(
        postSeriesProgramActionHandler(
          postData,
          dispatch,
          navigate,
          pathType,
          tenantName
        )
      ).then((response) => {
        if (response.status === 200) {
          if (formData?.details?.Certificate) {
            const certificateObj = {
              CertificateID: parseInt(formData?.details?.Certificate),
              ProgramName: formData.details.name,
              Title: formData?.details?.Title,
              Type: true,
            };
            dispatch(postCertificateActionHandler(certificateObj));
          }
          setSeriesLoader(false);
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              pathType === "copy"
                ? "Program Copied Successfully"
                : "Program Created Successfully"
            )
          );
          navigate(`${seriesManagement.path(tenantName)}`);
          // dispatch(setSeriesShotclassDataAction([]));
        }
      });
    }
  };
  const handleCancelBtn = () => {
    const updatedData = classTypeData?.map((item) => {
      if (item?.isChecked) {
        return { ...item, isChecked: true, disabled: true };
      } else {
        return item;
      }
    });
    dispatch(setSeriesShotclassDataAction(updatedData));
    setFormData((formData) => {
      return {
        ...formData,
        topicContent: {
          ...formData.topicContent,
          TopicCourseAssociations: elementsSelectedTopic,
        },
      };
    });
    // if (location.pathname !== addSeriesMgmt.editpath(tenantName)) {
    //   const updatedData = classTypeData?.map((item) => {
    //     if (item?.isChecked) {
    //       return { ...item, isChecked: true, disabled: false };
    //     } else {
    //       return item;
    //     }
    //   });
    //   dispatch(setSeriesShotclassDataAction(updatedData));
    // }
    // dispatch(setOrganizeContentDataAction(selectedTpc));
    dispatch(setSeriesShotclassDataAction([]));
    setCallDefaultApi(true);
  };

  const [topicCourseAss, setTopicCourseAss] = useState();
  const { hashTable: topicCourseAssList } = useHashArray(
    topicCourseAss,
    "ID",
    true
  );

  const { hashTable: selectedTopicItemsList } = useHashArray(
    selectedTpc,
    "ID",
    true
  );
  // console.log("selectedTopicItemsList", selectedTopicItemsList);
  const [searchDataResult, setSearchDataResult] = useState([]);
  const handleSearchBtn = useCallback(
    (e) => {
      let searchTxtValue = e.target.value.trim() !== "" && e.target.value;
      setActiveLoader(true);
      if (searchTxtValue) {
        setCallDefaultApi(false);
        setCheckSearchTxt(false);
        setPageNum(1);
        dispatch(
          searchProgramActionHandler(
            searchTxtValue,
            "Published",
            "en-GB",
            "Shotclass",
            searchTxtValue
          )
        ).then((response) => {
          if (response) {
            const updatedData = response.map((item) => {
              if (selectedTopicItemsList[item?.ShotClass?.ID]) {
                return {
                  ...item,
                  isChecked: true,
                  disabled: true,
                };
              } else {
                return { ...item, isChecked: false, disabled: false };
              }
            });
            // debugger;
            if (response.length > 0) {
              dispatch(setSeriesShotclassDataAction(updatedData));
            }
            setActiveLoader(false);
          }
        });
      } else {
        setActiveLoader(true);
        // debugger;
        // setCallDefaultApi(true);
        setCheckSearchTxt(true);
        // setSearchData(true);
        setPageNum(1);
        // dispatch(
        //   searchProgramActionHandler(
        //     searchTxtValue,
        //     "Published",
        //     "en-GB",
        //     "Shotclass",
        //     searchTxtValue
        //   )
        // );
        dispatch(
          getRecentlyAddNewSeriesActionHandler(
            "WithoutVTLT",
            "Published",
            "ShotClass",
            "none",
            "none",
            1,
            pageSize,
            true
          )
        ).then((response) => {
          const updatedData = response.data.map((item) => {
            if (selectedTopicItemsList[item?.ShotClass?.ID]) {
              return {
                ...item,
                isChecked: true,
                disabled: true,
              };
            } else {
              return { ...item, isChecked: false, disabled: false };
            }
          });
          // debugger;
          dispatch(setSeriesShotclassDataAction(updatedData));
          setActiveLoader(false);
        });
      }
    },
    [
      dispatch,
      setCallDefaultApi,
      setCheckSearchTxt,
      selectedTopicItemsList,
      topicCourseAssList,
      searchDataResult,
      setSearchDataResult,
      classTypeData,
      selectedTpc,
      setActiveLoader,
    ]
  );

  // const handleSearchBtn = (e) => {
  //   let searchTxtValue = e.target.value.trim() !== "" && e.target.value;
  //   if (searchTxtValue) {
  //     debugger;
  //     setCallDefaultApi(false);
  //     dispatch(
  //       searchProgramActionHandler(
  //         searchTxtValue,
  //         "Published",
  //         "en-GB",
  //         "Shotclass"
  //       )
  //     );
  //   } else {
  //     setCallDefaultApi(true);
  //   }
  // };

  // console.log(searchData)
  useEffect(() => {
    // if (
    //   location?.pathname?.includes(addSeriesMgmt?.editpath(tenantName)) ||
    //   location?.pathname?.includes(addSeriesMgmt?.copypath(tenantName))
    // ) {
    if (formData?.topicContent?.TopicCourseAssociations)
      setTopicCourseAss(formData?.topicContent?.TopicCourseAssociations);
    // }
  }, [
    location?.pathname,
    formData,
    formData?.topicContent?.TopicCourseAssociations,
  ]);

  // useEffect(() => {
  //   if (location?.pathname?.includes(addSeriesMgmt?.editpath(tenantName))) {
  //     setTopicCourseAss(formData?.topicContent?.TopicCourseAssociations);
  //   }
  // }, [location.pathname, formData]);
  // console.log(topicCourseAssList)
  // console.log("|| selectedTopicItemsList ", selectedTopicItemsList )
  useEffect(() => {
    if (
      // (location?.pathname?.includes(addSeriesMgmt.editpath(tenantName)) ||
      //   location?.pathname?.includes(addSeriesMgmt.copypath(tenantName))) &&
      topicCourseAssList !== undefined &&
      topicCourseAssList !== null &&
      Object.keys(topicCourseAssList)?.length !== 0
    ) {
      const updatedData = classTypeData?.map((item) => {
        if (topicCourseAssList[item?.ShotClass?.ID]) {
          return {
            ...item,
            isChecked: true,
            disabled: true,
          };
        } else {
          return { ...item };
        }
      });
      dispatch(setSeriesShotclassDataAction(updatedData));
      let arr = [];
      updatedData?.forEach((item) => {
        if (item.isChecked === true && item.disabled === true) {
          arr?.push(item?.ShotClass);
        }
      });
      // setSelectedTpc(arr);
      // setSelectedTpc(arr);
      setSelectedTpc(formData?.topicContent?.TopicCourseAssociations);
      // let insertIDAfterSearch = []
      // selectedTpc.forEach((item) => {
      //   insertIDAfterSearch.push(item.ID)
      // })
      // debugger;
      // console.log(insertIDAfterSearch)
    }
  }, [
    // dispatch,
    // location?.pathname,
    topicCourseAssList,
    //selectedTopicItemsList,
    setSeriesShotclassDataAction,
    //setSelectedTpc,
    // classTypeData,
    // handleSearchBtn,
    // searchData
  ]);
  const [elementsSelectedTopic, setElementsSelectedTopic] =
    useState(selectedTpc);
  useEffect(() => {
    setElementsSelectedTopic(selectedTpc);
  }, [selectedTpc]);

  const handleonDrag = (results) => {
    // console.log(results);
    const { source, destination } = results;
    if (!destination) {
      return;
    }
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }
    const reorderedStores = [...elementsSelectedTopic];
    const sourceIndex = source.index;
    const destinationIndex = destination.index;
    const [removedElement] = reorderedStores.splice(sourceIndex, 1);
    reorderedStores.splice(destinationIndex, 0, removedElement);
    return setElementsSelectedTopic(reorderedStores);
  };
  useEffect(() => {
    if (topicCourseAssList?.length !== undefined) {
      const updatedData = classTypeData?.map((item) => {
        if (topicCourseAssList[item?.ShotClass?.ID]) {
          return {
            ...item,
            isChecked: true,
            disabled: true,
          };
        } else {
          return { ...item };
        }
      });
      dispatch(setSeriesShotclassDataAction(updatedData));
    }
    if (selectedTopicItemsList?.length !== undefined) {
      const updatedData = classTypeData.map((item) => {
        if (selectedTopicItemsList[item?.ShotClass?.ID]) {
          return {
            ...item,
            isChecked: true,
            disabled: true,
          };
        } else {
          return { ...item };
        }
      });
      dispatch(setSeriesShotclassDataAction(updatedData));
    }
  }, [
    dispatch,
    topicCourseAssList,
    selectedTopicItemsList,
    classTypeData?.length,
    selectedTpc?.length,
  ]);
  return (
    <div className={classes.seriesContentMain}>
      <FormProvider {...methods}>
        {/* <h1 className={classes.title}>Available Shotclasses  & Selected Shotclasses</h1> */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.seriesFormsMain}>
            <div className={classes.seriesContentFormsMain}>
              <div className={classes.availableTopics}>
                <div className={classes.availableTopicsTitle}>
                  Available
                  {/* Available Shotclasses */}
                  {/* <div className={classes.infoIcon}>
                    <Tooltip
                      direction="right"
                      content={<FormattedMessage id="AVAILABLE_CLASSES" />}
                    >
                      <InfoIcon />
                    </Tooltip>
                  </div> */}
                </div>
                <div className={classes.seriesSearchInput}>
                  <Input
                    label={""}
                    name="tagname"
                    placeholder={"Search Tag or Name"}
                    search
                    width="auto"
                    onChange={(e) => handleSearchBtn(e)}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
                <div className={classes.seriesList}>
                  {activeLoader ? (
                    <div className={classes.loader}>
                      <Loader height="50" width="50" />
                    </div>
                  ) : classTypeData?.length > 0 ? (
                    <InfiniteScrollComponent
                      dataLength={
                        classTypeData?.length ? classTypeData.length : pageSize
                      }
                      fetchMoreData={fetchMoreData}
                      hasMoreData={hasMoreData}
                      height={classTypeData?.length > 0 ? "22rem" : "20vh"}
                      loader={
                        checkSearchTxt && classTypeData?.length > 14
                          ? true
                          : false
                      }
                    >
                      <ul>
                        {classTypeData?.map((item, index) => (
                          <li key={item?.ShotClass?.ID}>
                            <input
                              type="checkbox"
                              name={item?.ShotClass?.ID}
                              value={item?.ShotClass?.Name}
                              width="20px"
                              height="2"
                              id={item?.ShotClass?.ID}
                              disabled={item?.disabled}
                              checked={item?.isChecked}
                              onChange={(e) => {
                                handleTopics(e, item.ShotClass, index);
                              }}
                              onKeyDown={(e) => {
                                if (e.keyCode === 13) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <label htmlFor={item?.ShotClass?.ID}>
                              {item?.ShotClass?.Name}
                            </label>
                            <div className={classes.mediaTypes}>
                              {
                                // item?.Programs?.Mediatype ||
                                // item?.ShotClass?.Mediatype === 0 ? (
                                //   "Quiz and Survey"
                                // ) :
                                item?.Programs?.Mediatype ||
                                item?.ShotClass?.Mediatype === 1 ? (
                                  "Video"
                                ) : item?.Programs?.Mediatype ||
                                  item?.ShotClass?.Mediatype === 2 ? (
                                  "YouTube"
                                ) : item?.Programs?.Mediatype ||
                                  item?.ShotClass?.Mediatype === 3 ? (
                                  "PPT"
                                ) : item?.Programs?.Mediatype ||
                                  item?.ShotClass?.Mediatype === 4 ? (
                                  "O365Video"
                                ) : item?.Programs?.Mediatype ||
                                  item?.ShotClass?.Mediatype === 5 ? (
                                  "SlideShare"
                                ) : item?.Programs?.Mediatype ||
                                  item?.ShotClass?.Mediatype === 6 ? (
                                  "OneDrive"
                                ) : item?.Programs?.Mediatype ||
                                  item?.ShotClass?.Mediatype === 7 ? (
                                  "PDF"
                                ) : item?.Programs?.Mediatype ||
                                  item?.ShotClass?.Mediatype === 8 ? (
                                  "MOOC"
                                ) : item?.Programs?.Mediatype ||
                                  item?.ShotClass?.Mediatype === 9 ? (
                                  "Scorm"
                                ) : item?.Programs?.Mediatype ||
                                  item?.ShotClass?.Mediatype === 10 ? (
                                  "Image"
                                ) : item?.Programs?.Mediatype ||
                                  item?.ShotClass?.Mediatype === 11 ? (
                                  "HTML5"
                                ) : item?.ShotClass?.ShotClassType === 5 ? (
                                  "Quiz and Survey"
                                ) : item?.ShotClass?.ShotClassType === 6 ? (
                                  "Quiz"
                                ) : item?.Programs?.Mediatype ||
                                  item?.ShotClass?.ShotClassType === 7 ? (
                                  "Survey"
                                ) : (
                                  <></>
                                )
                              }
                            </div>
                          </li>
                        ))}
                      </ul>
                    </InfiniteScrollComponent>
                  ) : (
                    <div className={classes.noDataFound}>No Classes Found</div>
                  )}
                </div>
              </div>
              <div className={classes.nextPrvBtns}>
                <span
                  className={classes.nextBtn}
                  onClick={handleNextBtn}
                  disabled={selectedTopicData.length > 0 ? false : true}
                  style={{
                    border: `1px solid ${
                      selectedTopicData?.length > 0 ? "#14C037" : "#707070"
                    }`,
                  }}
                >
                  <NextIcon
                    fill={selectedTopicData?.length > 0 ? "#14C037" : "#707070"}
                  />
                </span>
                <span
                  className={classes.prevBtn}
                  onClick={handlePrevBtn}
                  // disabled={selectedTpc.length > 0 ? false : true}
                  disabled={!isClassSelected}
                  style={{
                    border: `1px solid ${
                      isClassSelected ? "#14C037" : "#707070"
                    }`,
                  }}
                >
                  <NextIcon fill={isClassSelected ? "#14C037" : "#707070"} />
                </span>
              </div>
              <div className={classes.availableTopics}>
                <div className={classes.availableTopicsTitle}>
                  {/* <FormattedMessage id="SELECTED_CLASSES" /> */}
                  {/* Selected Shotclasses */}
                  Selected
                </div>
                <div
                  className={`${classes.seriesList} ${classes.selectedSeriesList}`}
                >
                  <DragDropContext onDragEnd={handleonDrag}>
                    <Droppable
                      droppableId="selectedTopics"
                      key="selectedTopics"
                      type="selectedTpcTypeBox"
                    >
                      {(provided, snapshot) => {
                        return (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{
                              background: snapshot.isDraggingOver
                                ? "#f3f3f3"
                                : "",
                            }}
                          >
                            <ul>
                              {elementsSelectedTopic?.map((item, index) => {
                                return (
                                  <Draggable
                                    key={`SwappingList[${index}]`}
                                    draggableId={`selectedTopic-${index}`}
                                    index={index}
                                  >
                                    {(provided, snapshot) => {
                                      return (
                                        <div
                                          key={item?.ID}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={{
                                            backgroundColor: snapshot.isDragging
                                              ? "#dddddd"
                                              : "",
                                            ...provided.draggableProps.style,
                                          }}
                                        >
                                          <li key={item?.ID}>
                                            <input
                                              type="checkbox"
                                              name={item?.ID}
                                              value={item?.Name}
                                              width="20px"
                                              height="2"
                                              id={item?.ID}
                                              ref={provided.innerRef}
                                              onChange={(e) => {
                                                handleTrainingContent(e, item);
                                                setValue(
                                                  "TopicCourseAssociations",
                                                  selectedTpc
                                                );
                                              }}
                                              disabled={item?.disabled}
                                              style={{
                                                cursor:
                                                  item?.disabled &&
                                                  "not-allowed",
                                              }}
                                              error={errors?.training?.message}
                                            />
                                            <label htmlFor={item?.ID}>
                                              {item?.Name}
                                            </label>
                                            <div className={classes.typeCross}>
                                              {/* {item?.Type == "ShotClass" ? "Shotclass" : "Series"} */}
                                              <span
                                                onClick={() =>
                                                  handleCrossIcon(item)
                                                }
                                                style={{
                                                  cursor:
                                                    item?.disabled &&
                                                    "not-allowed",
                                                  pointerEvents:
                                                    item?.disabled && "none",
                                                }}
                                              >
                                                <CrossIcon
                                                  fill={colors.theme}
                                                />
                                              </span>
                                              <span
                                                {...provided.dragHandleProps}
                                              >
                                                <IoMdMove />
                                              </span>
                                            </div>
                                          </li>
                                        </div>
                                      );
                                    }}
                                  </Draggable>
                                );
                              })}
                            </ul>
                            {provided.placeholder}
                          </div>
                        );
                      }}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>

            <div className={classes.seriesBtns}>
              {/* {selectedTpc.length == 0 && ( */}
              <div
                className={classes.clearAll}
                onClick={() => {
                  navigate(
                    `${addSeriesMgmt.path(
                      location,
                      routerParam,
                      tenantName
                    )}/details`
                  );
                  handleCancelBtn();
                }}
              >
                {/* <FormattedMessage id="CANCEL_TEXT" /> */}
                <FormattedMessage id="PAGINATION_PREVIOUS" />
              </div>
              {/* )} */}
              {/* {selectedTpc.length > 0 && (
              <div className={classes.clearAll} onClick={clearAll}>
                <FormattedMessage id="CLEAR_ALL_TXT" />
              </div>
            )} */}
              <Button
                label={<FormattedMessage id="SAVE_TXT" />}
                small
                dark
                onClick={saveSeries}
                disabled={selectedTpc.length > 0 ? false : true}
                backgroundColor={seriesLoader ? undefined : "#D31B61"}
                loading={seriesLoader}
              />
              <Button
                label={
                  pathType === "edit" &&
                  dataForUpdateProgramByID?.[0]?.Programs?.IsPublished ? (
                    "Unpublish"
                  ) : (
                    <FormattedMessage id="CREATE_PUBLISH_TEXT" />
                  )
                }
                small
                dark
                type={<FormattedMessage id="CREATE_SUBMIT_TEXT" />}
                disabled={!isValid || selectedTpc.length > 0 ? false : true}
                onClick={setValue("publishbtn", true)}
                backgroundColor={seriesPublishLoader ? undefined : "#D31B61"}
                loading={seriesPublishLoader}
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default SeriesContent;
